import React, { useEffect, useState } from "react";
import { api, CAD } from "../lib/api";
import { useNavigate } from "react-router-dom";
import { FileText, GraduationCap, School, Building2, Clock, CheckCircle2, DollarSign, Users } from "lucide-react";

const KPI = ({ label, value, icon: Icon, tone = "slate", testid, onClick }) => (
  <button onClick={onClick} data-testid={testid}
       className="text-left bg-white p-4 rounded-xl border border-slate-200 shadow-sm hover:shadow-md transition-shadow">
    <div className="flex items-start justify-between">
      <div>
        <div className="text-xs uppercase tracking-wide text-slate-500 font-medium">{label}</div>
        <div className="heading-font text-2xl font-bold mt-1 text-slate-900">{value}</div>
      </div>
      <div className={`w-9 h-9 rounded-lg flex items-center justify-center bg-${tone}-50 text-${tone}-600`}>
        <Icon className="w-4 h-4" />
      </div>
    </div>
  </button>
);

export default function B2CDashboard() {
  const [stats, setStats] = useState({});
  const nav = useNavigate();
  useEffect(() => { api.get("/b2c/dashboard").then(r=>setStats(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div><h1 className="heading-font text-3xl font-bold text-slate-900">B2C Dashboard</h1><p className="text-sm text-slate-500 mt-1">Student → Application → Filing → Enrollment → Commission.</p></div>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-5 gap-4">
        <KPI testid="b2c-kpi-students" label="Total Students" value={stats.total_students||0} icon={Users} tone="blue" onClick={()=>nav("/b2c/students")}/>
        <KPI testid="b2c-kpi-apps" label="Applications" value={stats.total_applications||0} icon={FileText} tone="indigo" onClick={()=>nav("/b2c/applications")}/>
        <KPI label="New" value={stats.new_applications||0} icon={Clock} tone="sky" />
        <KPI label="Docs Pending" value={stats.documents_pending||0} icon={Clock} tone="amber" />
        <KPI label="Applied" value={stats.applied||0} icon={FileText} tone="blue" />
        <KPI label="Offers" value={stats.offers||0} icon={CheckCircle2} tone="emerald" />
        <KPI label="Fees Pending" value={stats.fees_pending||0} icon={DollarSign} tone="yellow" />
        <KPI label="Admission Complete" value={stats.admission_complete||0} icon={GraduationCap} tone="green" />
        <KPI label="PAL Pending" value={stats.pal_pending||0} icon={Clock} tone="amber" />
        <KPI label="Filing Active" value={stats.filing_active||0} icon={Building2} tone="purple" />
        <KPI label="Filing Approved" value={stats.filing_approved||0} icon={CheckCircle2} tone="green" />
        <KPI label="Enrollment Pending" value={stats.enrollment_pending||0} icon={School} tone="orange" />
        <KPI label="Sem 1 Enrolled" value={stats.sem1_enrolled||0} icon={GraduationCap} tone="teal" />
        <KPI label="Sem 2 Enrolled" value={stats.sem2_enrolled||0} icon={GraduationCap} tone="teal" />
        {stats.commission_received_count != null && <>
          <KPI label="Invoices Pending" value={stats.invoice_pending||0} icon={FileText} tone="amber" />
          <KPI label="Invoices Sent" value={stats.invoice_sent||0} icon={FileText} tone="blue" />
          <KPI label="Commissions Received" value={stats.commission_received_count||0} icon={CheckCircle2} tone="emerald" />
          <KPI label="Commission Total" value={CAD(stats.commission_received_amount||0)} icon={DollarSign} tone="green" />
        </>}
      </div>
    </div>
  );
}
